<template>
  <div v-loading="loading" class="resultDiv">
    <table v-if="isShow">
      <tbody id="topSearch">
        <tr v-for="(item, index) in HotData" :key="index">
          <td
            :class="[
              index + 1 === 1
                ? 'top1'
                : index + 1 === 2
                ? 'top2'
                : index + 1 === 3
                ? 'top3'
                : ''
            ]"
            :title="item.Title"
            @click="SearchWords(item.Title, item.ResourceGuid)"
          >
            <span>{{ index + 1 }}</span>
            <span>{{ escape2Html(item.Title) }}</span>
          </td>
          <td :title="item.Note">
            {{ item.Note }}
          </td>
        </tr>
      </tbody>
    </table>
    <HotArticleHistoryList
      @pageIndexNum="pageIndexNum"
      :txt-type="txtType"
      :get-history-guid="getHistoryGuid"
    ></HotArticleHistoryList>
  </div>
</template>

<script>
import HotArticleHistoryList from "./HotHistoryList";
export default {
  name: "HotArticleList",
  props: ["HotData", "getHistoryGuid", "txtType"],
  components: {
    HotArticleHistoryList
  },
  data() {
    return {
      tableHeight: 700,
      loading: false,
      isShow: true
    };
  },
  methods: {
    SearchWords(keyword, guid) {
      if (this.txtType === "word") {
        this.$router.push("/material/article/" + encodeURIComponent(keyword));
      } else {
        this.$router.push("/article/hotBd/" + guid);
      }
    },
    pageIndexNum(index) {
      index > 1 ? (this.isShow = false) : (this.isShow = true);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/mixin";
@import "../../assets/style/color";
.resultDiv {
  /*padding: 5px 10px;*/
  /*border: 1px solid #d3d7de;*/
  margin: 5px 5px;
  min-height: 150px;
  width: 460px;
  color: #666;
  font-size: 12px;
  height: 100%;
  .bodyMain {
    height: 700px;
    overflow-y: auto;
    overscroll-behavior-y: contain;
  }
  table tbody {
    display: block;
  }
  table thead,
  tbody tr,
  tfoot tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  table thead {
    width: calc(100% - 1em);
  }

  table {
    width: 100%;
    text-align: left;
    td,
    th {
      border: 0;
      display: inline-block;
      .ellipsis();
      &:nth-child(1) {
        width: 85%;
        cursor: pointer;
      }
      &:nth-child(2) {
        width: 15%;
      }
      span {
        padding-right: 5px;
      }
    }
    tbody {
      tr {
        line-height: 30px;
        &:hover {
          background-color: @body-background-color;
        }
        border-bottom: 1px solid @borderbottom;
      }
    }
    tbody:before {
      content: "-";
      display: block;
      line-height: 1px;
      color: transparent;
    }
    th {
      font-weight: 500;
      color: #909399;
    }
  }
  .top1 {
    color: red;
  }
  .top2 {
    color: #fea040;
  }
  .top3 {
    color: #b48e5b;
  }
}
</style>
